module.exports = __webpack_public_path__ + "static/media/creditCardWarning.e61ced46.svg";